import { call, put } from 'redux-saga/effects'
import firebase from 'firebase/app'
import Hasura from '../config/hasura'
import DriverTransactionActions from '../reducers/driverTransactionReducer'

export function* getDriverTransactions({ startedAt, endedAt }) {
  try {
    const ref = firebase.database().ref('deliverers')
    const driversSnapshot = yield call([ref, ref.once], 'value')
    const drivers = driversSnapshot.val() || {}

    const query = `
      query($merchantKey: String){
        deliverer_transactions(where: {created_at: {_gte: "${startedAt}", _lte: "${endedAt}"}}) {
          amount
          created_at
          deliverer_id
          description
          order_id
          id
        }
      }
    `

    const transactions = {}
    const { deliverer_transactions: driverTransactions } = yield call(Hasura.execute, query)

    if (driverTransactions.length > 0) {
      driverTransactions.forEach(transaction => {
        transactions[transaction.id] = { ...transaction, key: transaction.deliverer_id }
      })
    }

    yield put(DriverTransactionActions.setTransactions(drivers, transactions))
  } catch (e) {
    yield put(DriverTransactionActions.setTransactions({}, {}))
  }
}



// WEBPACK FOOTER //
// ./src/sagas/driverTransactionSaga.js